import styled from 'styled-components';
import { lightenHex } from '../utils/annotationPresentation';
import ContainerBase from '../../../common/components/atoms/Container';

export const Container = styled(ContainerBase)`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.greyL};
  border-radius: ${(props) => props.theme.utils.borderRadius};
  padding: 16px;
  box-shadow: none;
  margin-bottom: 16px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0; /* equal top and bottom spacing */
`;

export const TypeButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid ${(props) => (props.isActive ? lightenHex(props.color, 48) : props.theme.colors.grey)};
  background: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.greyXXD};
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
  opacity: ${(props) => (props.isActive ? 1 : 0.9)};

  &:hover {
    opacity: 1;
    transform: translateY(-1px);
    background: ${(props) => props.theme.colors.greyXXXL};
    border-color: ${(props) => (props.isActive ? lightenHex(props.color, 72) : props.theme.colors.borderGrayHover)};
  }

  &:active {
    transform: translateY(0);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.borderActive};
  }
`;

export const Icon = styled.span`
  font-size: 14px;
  line-height: 1;
`;

export const Label = styled.span`
  font-size: 13px;
`;

export const CompactInfo = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.greyXD};
`;

export const ColorDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => (props.isActive ? lightenHex(props.color, 48) : props.theme.colors.grey)};
  opacity: ${(props) => (props.isActive ? 1 : 0.5)};
  box-shadow: 0 0 0 1px rgba(0,0,0,0.05);
`;
